<template lang="html">
  <v-card class="pa-3">
    <v-layout align-center justify-space-between row>

      <v-flex grow>
        Tradução
      </v-flex>

      <v-flex shrink>
        <span class="mr-2 pointer" :class="{'bold primary--text': $route.params.language == 'pt'}" @click="selectLanguage('pt')">PT</span>
        <span class="mr-2 pointer" :class="{'bold primary--text': $route.params.language == 'en'}" @click="selectLanguage('en')">EN</span>
        <span class="mr-2 pointer" :class="{'bold primary--text': $route.params.language == 'es'}" @click="selectLanguage('es')">ES</span>
      </v-flex>

    </v-layout>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  props:{
    albumId: {
      type: Number
    }
  },
  methods: {
    ...mapActions([
      'downloadAlbum',
    ]),
    selectLanguage: function (lang) {
      // this.$router.push({ name: 'AlbumView', params: { albumId: this.albumId, language: lang } })
      this.$route.params.language = lang
      this.downloadAlbum({
        language: lang,
        id: this.albumId
      })
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
